import MaleDeveloper from '../images/aboutUs/male-developer.png';
import FemaleDeveloper from '../images/aboutUs/female-developer.png';

export const aboutUsAvatarList = [
  MaleDeveloper,
  FemaleDeveloper,
  FemaleDeveloper,
];
